import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { browserHistory } from 'react-router';
import axios from 'axios';
import { setSubscriptionEmail, stopSubmitForm, submitForm, getNextStep } from '../actions/users';
import validate from '../components/Validations/submitValidationsAuthForm';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import AuthForm from '../components/AuthForm.js';

const mapStateToProps = (state, ownProps) => {

    return {
        isValidating: false,
        isLoading: state.users.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        //For any field errors upon submission (i.e. not instant check)
        changeSubscriptionEmail(values, dispatch, ownProps) {
            dispatch(submitForm());

            let errors = validate(values);

            if( Object.keys(errors).length !== 0){
                const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
                return sleep(10).then(() => {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError({ ...errors, _error: 'Revisá los campos indicados.' })
                })
            }
            return dispatch(setSubscriptionEmail({ ...values})).then((result) => {
                    let jwt =  sessionStorage.getItem('jwtAuthToken');
                    const ROOT_URL = process.env.API_URL;
                    var config = {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    };

                    return axios.get(`${ROOT_URL}/leads/jwt/${jwt}`, config)
                        .then(res => {
                            sessionStorage.setItem('jwtToken', res.data['access_token']);
                            dispatch(getNextStep()).then((result) => {
                                if (typeof(result.payload.data.endpoint) !== 'undefined') {
                                    sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                                    dispatch(stopSubmitForm());
                                    browserHistory.push({
                                        pathname: result.payload.data.endpoint,
                                    });
                                }
                            });
                        })
                }).catch(result => {
                    if (result.response && result.response.status !== 200) {
                        dispatch(stopSubmitForm());
                        throw new SubmissionError({...getErrorsApiToReduxForm(result.response.data), _error: 'Revisá los campos indicados.'});
                    }
                });
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthForm);



/** WEBPACK FOOTER **
 ** ./src/containers/AuthFormContainer.js
 **/